// Example: To understand how it works
import { ActionContext, ActionTree } from 'vuex';
import { SET_CITIES } from './mutation-types';
import State from './state';
import RootState from '../../state'
import commonApiRemote from "../../../services/commonApiRemote";
import appWebConfig from '../../../../../../app.web.config';
import humps = require('humps');

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, RootState> = {
	getCities({ commit }: ActionContext<State, RootState>, data: any): void {
		//debugger;
		commonApiRemote(appWebConfig.private.database.cities).getData().then((rsp: any) => {
			//debugger;
			let cities: any = humps.camelizeKeys(rsp.data.cities);
			commit(SET_CITIES, cities);
		});
	}
};

export default actions;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/cities/actions.ts